import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Button, Spin } from "antd";
import { toast } from "../../components/toasts/toastStore";
import { actionLogin } from "../../redux/actions/login/login";
import { Form, FloatingLabel } from "react-bootstrap";
import ModalOlvidar from "../../components/modals/ModalOlvidar";
import logo from "../../assets/img/logo-icon.png";
import "../../assets/css/loginVoyager.css";

function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const passwordInput = useRef(null);
  const [showUsuarioOptions, setShowUsuarioOptions] = useState(false);

  const [show, setShow] = useState(false);
  const [usuario, setUsuario] = useState("");
  const [usuarioOptions, setUsuarioOptions] = useState([]);

  useEffect(() => {
    try {
      const saved = JSON.parse(localStorage.getItem("usuario_history") || "[]");
      if (Array.isArray(saved)) setUsuarioOptions(saved);
    } catch {
      setUsuarioOptions([]);
    }
  }, []);

  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const openNotification = (msg) => {
    toast.error(msg || "Error");
  };

  const checkFields = () => {
    if (usuario.trim().length === 0 || password.trim().length === 0) {
      openNotification("Completa usuario y contraseña.");
      return false;
    }
    return true;
  };

  const callback = () => {
    navigate("/app/home");
  };

  const callbackError = (value) => {
    setLoading(false);
    openNotification(value);
  };

  const acceptButtonHandler = () => {
    if (!checkFields()) return;
    setLoading(true);
    dispatch(actionLogin({ usuario, password }, callback, callbackError));
  };

  const handleKeyDownUsuario = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      passwordInput.current?.focus();
    }
  };

  const handleKeyDownPassword = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      acceptButtonHandler();
    }
  };

  return (
    <div className="login-wrapper fade-in">
      <div className="login-container">
        <div className="login-left">
          <div className="text-center">
            <img src={logo} alt="Gigante Jr. logo" style={{ width: 140 }} />
            <h2 className="login-title">Iniciar sesión</h2>
            <p className="login-subtitle">Multiproductos y Servicios</p>
          </div>

          <form className="login-form" noValidate>
            <FloatingLabel controlId="floatingUsuario" label="Usuario" className="mb-3">
              <Form.Control
                value={usuario}
                onChange={(e) => setUsuario(e.target.value)}
                type="text"
                name="usuario"
                placeholder="usuario"
                onKeyDown={handleKeyDownUsuario}
                aria-label="Usuario"
                autoComplete="off"
                onFocus={() => setShowUsuarioOptions(true)}
                onBlur={() => setTimeout(() => setShowUsuarioOptions(false), 120)}
              />

              {showUsuarioOptions && usuarioOptions.length > 0 && (
                <div className="usuario-options-box">
                  {usuarioOptions
                    .filter((opt) => opt.toLowerCase().includes(usuario.toLowerCase()))
                    .map((opt) => (
                      <div
                        key={opt}
                        className="usuario-option-item"
                        onMouseDown={() => {
                          setUsuario(opt);
                          passwordInput.current?.focus();
                        }}
                      >
                        {opt}
                      </div>
                    ))}
                </div>
              )}
            </FloatingLabel>

            <FloatingLabel controlId="floatingPassword" label="Contraseña">
              <Form.Control
                onChange={(e) => setPassword(e.target.value)}
                type="password"
                name="password"
                placeholder="Contraseña"
                ref={passwordInput}
                onKeyDown={handleKeyDownPassword}
                aria-label="Password"
              />
            </FloatingLabel>

            <Button
              type="primary"
              block
              className="custom-button mt-3"
              onClick={acceptButtonHandler}
              disabled={loading}
            >
              {loading ? <Spin size="small" /> : "Iniciar sesión"}
            </Button>

            <div className="forgot-password-link">
              <span className="link-pointer" onClick={() => setShow(true)}>
                ¿Olvidaste tu contraseña?
              </span>
            </div>
          </form>
        </div>

        <div className="login-right" role="presentation" />
      </div>

      <ModalOlvidar show={show} setShow={setShow} />
    </div>
  );
}

export default Login;
